import { EquipItemCommand } from "../../core/commands/EquipItemCommand";
import { findItem } from "../../inventory/Inventory";
import { hasComponent } from "../../world/Entity";
import type { EntityComponent } from "../../world/components";
import type { Interaction } from "../Interaction";

export function wearableOf(components: readonly EntityComponent[] | undefined) {
  return components?.find((c): c is Extract<EntityComponent, { type: "wearable" }> => c.type === "wearable");
}

export const wearInteraction: Interaction = {
  id: "wear",
  label: "Wear",
  scope: "inventory",
  canExecute: (ctx) => {
    if (!ctx.instanceId || !ctx.actorId) return false;
    const item = findItem(ctx.world.inventory, ctx.instanceId);
    const meta = item?.metadata as { components?: EntityComponent[] } | undefined;
    if (!wearableOf(meta?.components)) return false;
    const character = ctx.world.getEntity(ctx.actorId);
    return character !== undefined && hasComponent(character, "character");
  },
  execute: async (ctx) => {
    if (!ctx.instanceId || !ctx.actorId) return { success: false };
    const item = findItem(ctx.world.inventory, ctx.instanceId);
    const meta = item?.metadata as { components?: EntityComponent[] } | undefined;
    const wearable = wearableOf(meta?.components);
    if (!wearable) return { success: false };
    ctx.commands.execute(new EquipItemCommand(ctx.actorId, ctx.instanceId, wearable.slot));
    return { success: true };
  },
};
